import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-[#FBFAF6]">
      <div className="dwx py-20">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-4">
            <Logo size={38} inverted />
            <p className="mt-6 text-[13px] leading-relaxed text-[#FBFAF6]/70 max-w-sm">
              Transformation and engineering partner. We build and run enterprise systems using NeuralWorks — our framework for making AI delivery safe enough to reach production.
            </p>
          </div>
          <div className="col-span-6 sm:col-span-3 lg:col-span-2">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#FBFAF6]/50 mb-4">What We Do</div>
            <ul className="space-y-3 text-[13px]">
              <li><Link className="link-sweep" to="/what-we-do/ai-strategy-and-advisory">Strategy &amp; Advisory</Link></li>
              <li><Link className="link-sweep" to="/what-we-do/ai-native-engineering">Engineering &amp; Agent-Assisted Delivery</Link></li>
              <li><Link className="link-sweep" to="/what-we-do/platform-and-commerce-modernisation">Platform Modernisation</Link></li>
              <li><Link className="link-sweep" to="/what-we-do/run-and-optimise">Run &amp; Optimise</Link></li>
            </ul>
          </div>
          <div className="col-span-6 sm:col-span-3 lg:col-span-2">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#FBFAF6]/50 mb-4">NeuralWorks</div>
            <ul className="space-y-3 text-[13px]">
              <li><Link className="link-sweep" to="/neuralworks">Framework</Link></li>
              <li><Link className="link-sweep" to="/neuralworks/how-it-works">How it works</Link></li>
              <li><Link className="link-sweep" to="/neuralworks/accelerators">Accelerators</Link></li>
              <li><Link className="link-sweep" to="/neuralworks/security-and-governance">Security &amp; Governance</Link></li>
              <li><Link className="link-sweep" to="/trust">Trust &amp; Governance</Link></li>
            </ul>
          </div>
          <div className="col-span-6 sm:col-span-3 lg:col-span-2">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#FBFAF6]/50 mb-4">Company</div>
            <ul className="space-y-3 text-[13px]">
              <li><Link className="link-sweep" to="/about">About</Link></li>
              <li><Link className="link-sweep" to="/careers">Careers</Link></li>
              <li><Link className="link-sweep" to="/insights">Insights</Link></li>
            </ul>
          </div>
          <div className="col-span-6 sm:col-span-3 lg:col-span-2">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#FBFAF6]/50 mb-4">Contact</div>
            <ul className="space-y-3 text-[13px]">
              <li><a className="link-sweep inline-flex items-center gap-1" href="mailto:connect@digitalworks.co">connect@digitalworks.co <ArrowUpRight size={12} /></a></li>
              <li className="text-[#FBFAF6]/60">Dubai</li>
              <li><Link className="link-sweep" to="/contact">Book a session</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#FBFAF6]/15 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="text-[11px] text-[#FBFAF6]/50">© 2026 DigitalWorks Consulting Group. All rights reserved.</div>
          <div className="flex gap-6 text-[11px] text-[#FBFAF6]/50">
            <Link to="/legal/privacy" className="link-sweep">Privacy Policy</Link>
            <Link to="/legal/terms" className="link-sweep">Terms</Link>
            <Link to="/legal/cookies" className="link-sweep">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
